import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function useSetLocalProduct() {
  const [loading, setLoading] = useState(true);
  const [search] = useSearchParams();

  useEffect(() => {
    const type = search.get("type");
    const dynamicId = search.get("dynamic-id");
    const dynamicKeyword = search.get("dynamic-keyword");

    if (type) {
      localStorage.setItem("product-type", JSON.stringify(type));
    }

    if (dynamicId && dynamicKeyword) {
      localStorage.setItem(
        "dynamic",
        JSON.stringify({
          dynamicId,
          dynamicKeyword,
        })
      );
    }

    const t = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(t);
  }, [search]);

  return loading;
}
